import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { Authorization } from "../../common/AuthorizationCpt";
import { BETA_FEATURES } from "../../utils/constants";
import {
  REPORT_CREATE_APPOINTMENTS_REPORT,
  REPORT_CREATE_VOLANTES_REPORT,
  REPORT_GET_APPOINTMENTS_REPORT,
  REPORT_GET_REPORTS,
  REPORT_GET_VOLANTES_REPORT,
} from "../../utils/permissionConstant";
import { ADMIN_ROUTES } from "../../utils/routeConstants";
import Dropdown from "./Dropdown";
import {
  AdminButton,
  Container,
  SubItem,
  UnorderedList,
} from "./SideMenuStyles";

function AdminSideMenu() {
  const history = useHistory();
  const [pathname, setPathname] = useState(history.location.pathname);

  useEffect(() => {
    const unsub = history.listen((location) => {
      setPathname(location.pathname);
    });
    return () => {
      unsub();
    };
  }, [history]);

  return (
    <Container>
      <UnorderedList>
        <Authorization
          actions={[
            "dam.get_dam_senasa_admin",
            "invoice.get_invoice_upfront_manual",
            "appointment.get_appointment_admin_turn",
            "timeslot-by-date.get_timeslot_by_date",
            "timeslot-by-date.create_timeslot_by_date",
            "timeslot-by-date.update_timeslot_by_date",
            "appointment.get_appointment_admin_track",
            "invoice.get_invoice_upfront",
            "invoice.patch_invoice_upfront",
            "quotation.get_quotation_paid_backoffice",
            "dam.get_dam_estimate_backoffice",
          ]}
        >
          <Dropdown title="Importación">
            <Authorization actions={["dam.get_dam_senasa_admin"]}>
              <SubItem>
                <AdminButton
                  isActive={pathname === ADMIN_ROUTES.DOCUMENT_VALIDATION.path}
                  onClick={() =>
                    history.push(ADMIN_ROUTES.DOCUMENT_VALIDATION.path)
                  }
                >
                  {ADMIN_ROUTES.DOCUMENT_VALIDATION.title}
                </AdminButton>
              </SubItem>
            </Authorization>
            <Authorization actions={["invoice.get_invoice_upfront_manual"]}>
              <SubItem>
                <AdminButton
                  isActive={pathname === ADMIN_ROUTES.PAYMENT_VALIDATION.path}
                  onClick={() =>
                    history.push(ADMIN_ROUTES.PAYMENT_VALIDATION.path)
                  }
                >
                  {ADMIN_ROUTES.PAYMENT_VALIDATION.title}
                </AdminButton>
              </SubItem>
            </Authorization>
            <Authorization
              actions={[
                "invoice.get_invoice_upfront",
                "invoice.patch_invoice_upfront",
              ]}
            >
              <SubItem>
                <AdminButton
                  isActive={pathname === ADMIN_ROUTES.PAYMENT_RECAUDO.path}
                  onClick={() =>
                    history.push(ADMIN_ROUTES.PAYMENT_RECAUDO.path)
                  }
                >
                  {ADMIN_ROUTES.PAYMENT_RECAUDO.title}
                </AdminButton>
              </SubItem>
            </Authorization>

            <Authorization actions={["appointment.get_appointment_admin_turn"]}>
              <SubItem>
                <AdminButton
                  isActive={pathname === ADMIN_ROUTES.TURN_CONFIRMATION.path}
                  onClick={() =>
                    history.push(ADMIN_ROUTES.TURN_CONFIRMATION.path)
                  }
                >
                  {ADMIN_ROUTES.TURN_CONFIRMATION.title}
                </AdminButton>
              </SubItem>
            </Authorization>
            <Authorization
              actions={[
                "timeslot-by-date.get_timeslot_by_date",
                "timeslot-by-date.create_timeslot_by_date",
                "timeslot-by-date.update_timeslot_by_date",
              ]}
            >
              <SubItem>
                <AdminButton
                  isActive={
                    pathname === ADMIN_ROUTES.APPOINTMENT_CONFIGURATION.path
                  }
                  onClick={() =>
                    history.push(ADMIN_ROUTES.APPOINTMENT_CONFIGURATION.path)
                  }
                >
                  {ADMIN_ROUTES.APPOINTMENT_CONFIGURATION.title}
                </AdminButton>
              </SubItem>
            </Authorization>
            <Authorization
              actions={["appointment.get_appointment_admin_track"]}
            >
              <SubItem>
                <AdminButton
                  isActive={pathname === ADMIN_ROUTES.APPOINTMENT_TICKETS.path}
                  onClick={() =>
                    history.push(ADMIN_ROUTES.APPOINTMENT_TICKETS.path)
                  }
                >
                  {ADMIN_ROUTES.APPOINTMENT_TICKETS.title}
                </AdminButton>
              </SubItem>
            </Authorization>
            <Authorization
              actions={[
                "quotation.get_quotation_paid_backoffice",
                "dam.get_dam_estimate_backoffice",
              ]}
            >
              <SubItem>
                <AdminButton
                  isActive={
                    pathname === ADMIN_ROUTES.ORDERS.path ||
                    pathname === ADMIN_ROUTES.PAYMENT.path
                  }
                  onClick={() => history.push(ADMIN_ROUTES.ORDERS.path)}
                >
                  {ADMIN_ROUTES.BILLING_USERS_ADMIN.title}
                </AdminButton>
              </SubItem>
            </Authorization>

            <Authorization
              actions={[
                "volante.synchronize_volantes_by_volante_number",
                "volante.synchronize_volantes_by_manifest_number",
                "volante.synchronize_volantes_by_house_air_waybill",
                "user.synchronize_users_by_name",
                "user.synchronize_users_by_document_number",
                "billable-ruc.synchronize_agency_by_ruc",
              ]}
            >
              <SubItem>
                <AdminButton
                  isActive={pathname === ADMIN_ROUTES.SYNC_DATA.path}
                  onClick={() => history.push(ADMIN_ROUTES.SYNC_DATA.path)}
                >
                  {ADMIN_ROUTES.SYNC_DATA.title}
                </AdminButton>
              </SubItem>
            </Authorization>
            <Authorization
              actions={[
                REPORT_GET_VOLANTES_REPORT,
                REPORT_CREATE_VOLANTES_REPORT,
                REPORT_GET_APPOINTMENTS_REPORT,
                REPORT_CREATE_APPOINTMENTS_REPORT,
                REPORT_GET_REPORTS,
              ]}
            >
              <SubItem>
                <AdminButton
                  isActive={pathname === ADMIN_ROUTES.REPORTS.path}
                  onClick={() => {
                    if (pathname !== ADMIN_ROUTES.REPORTS.path) {
                      history.push(ADMIN_ROUTES.REPORTS.path);
                    }
                  }}
                >
                  {ADMIN_ROUTES.REPORTS.title}
                </AdminButton>
              </SubItem>
            </Authorization>
          </Dropdown>
        </Authorization>
        {BETA_FEATURES.COMPLAINTS_SCREEN && (
          <Dropdown title="Quejas y Reclamos">
            <SubItem>
              <AdminButton
                isActive={pathname === ADMIN_ROUTES.COMPLAINTS.path}
                onClick={() => history.push(ADMIN_ROUTES.COMPLAINTS.path)}
              >
                {ADMIN_ROUTES.COMPLAINTS.title}
              </AdminButton>
            </SubItem>

            <SubItem>
              <AdminButton
                isActive={pathname === ADMIN_ROUTES.CREATE_COMPLAINTS.path}
                onClick={() =>
                  history.push(ADMIN_ROUTES.CREATE_COMPLAINTS.path)
                }
              >
                {ADMIN_ROUTES.CREATE_COMPLAINTS.title}
              </AdminButton>
            </SubItem>
          </Dropdown>
        )}
        <Authorization actions={["user.get_users"]}>
          {BETA_FEATURES.USERS_SCREEN && (
            <Dropdown title="Usuarios">
              <SubItem>
                <AdminButton
                  isActive={pathname === ADMIN_ROUTES.ADMIN_USERS.path}
                  onClick={() => history.push(ADMIN_ROUTES.ADMIN_USERS.path)}
                >
                  {ADMIN_ROUTES.ADMIN_USERS.title}
                </AdminButton>
              </SubItem>
            </Dropdown>
          )}
        </Authorization>
      </UnorderedList>
    </Container>
  );
}

export default AdminSideMenu;
